(function (mod) {
    window.$modules = mod = mod || {};

    mod['product-card'] = context => {
        const { $el } = context;
        const $lighboxButton = $el.find('.show-lightbox');
        const $modal = $el.find('.modal');
        const $closeButton = $modal.find('.close-button');
        const bsModal = new bootstrap.Modal($modal.get(0), {
            keyboard: false,
            backdrop: 'static'
        });
        const $prev = $el.find('.arrow-prev');
        const $next = $el.find('.arrow-next');
        const $slides = $el.find('.image.slide');
        const $galleryIndex = $el.find('.gallery-index');

        let currentSlide = 0;
        let thinking = false;

        const showModal = () => {
            bsModal.show();
            return false;
        }

        const closeModal = () => {
            bsModal.hide();
            return false;
        }

        const toSlide = (slide) => {
            if (thinking) {
                return false;
            }
            if (slide == currentSlide) {
                return false;
            }
            if (slide > $slides.length - 1) {
                slide = 0;
            }
            if (slide < 0) {
                slide = $slides.length - 1;
            }
            currentSlide = slide;
            $slides.addClass('d-none');
            console.log(currentSlide);
            thinking = true;

            const $newSlide = $slides.eq(slide)
                .hide()
                .removeClass('d-none')
                .fadeIn('slow', function () {
                    thinking = false;
                });

            $galleryIndex.text(currentSlide + 1);
            currentSlide = slide;
            return false;
        }

        const nextSlide = () => {
            return toSlide(currentSlide + 1);
        }

        const prevSlide = () => {
            return toSlide(currentSlide - 1);
        }

        const init = () => {
            $lighboxButton.click(showModal);
            $closeButton.click(closeModal);
            $prev.click(prevSlide);
            $next.click(nextSlide);
        }
        init();
    }
})(window.$modules);